import { render, staticRenderFns } from "./DriverDashboard.vue?vue&type=template&id=bd8dda58"
import script from "./DriverDashboard.vue?vue&type=script&lang=js"
export * from "./DriverDashboard.vue?vue&type=script&lang=js"
import style0 from "./DriverDashboard.vue?vue&type=style&index=0&id=bd8dda58&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports